import React from "react";
import { Stack, Typography } from "@mui/material";
import { StyledCard } from "./styles";

export const DashboardCard = ({
  title,
  action,
  children,
  minHeight = 400,
  sx = {},
}) => (
  <StyledCard sx={sx} minHeight={minHeight} padding="20px">
    <Stack direction="row" justifyContent="space-between" alignItems="center">
      <Typography variant="caption" sx={{ fontSize: "12px", fontWeight: 500 }}>
        {title}
      </Typography>
      {action}
    </Stack>
    <Stack flex={1} sx={{ overflow: "auto" }}>
      {children}
    </Stack>
  </StyledCard>
);

export default DashboardCard;
